import { fetchAPI } from '../utils/api';

export const buyShopItem = (
  channelId: number,
  shopItemId: number
): Promise<Response> =>
  fetchAPI(`/channels/${channelId}/shop/items/${shopItemId}/buy`, {
    method: 'POST',
  });

export const topUpGoldAccount = (shopItem: ShopItem) =>
  fetchAPI('/account/gold/topup', {
    method: 'POST',
    payload: { amount: shopItem.credit_cost },
  });

export const getDataItemPrices = (payload: {
  ids: number[];
  from?: string;
  to?: string;
  currency?: string;
  bookmark?: number;
}): Promise<{ items: DataItem[] }> =>
  fetchAPI('/self/data_item/prices', {
    version: '1.2',
    payload,
  }).then(r => r.json());

export const postBookmarkDataItemPrices = (payload: {
  id: number;
  is_bookmark: boolean;
}) =>
  fetchAPI('/self/data_item/prices/bookmark', {
    method: 'POST',
    version: '1.2',
    payload,
  });

export const getReferencePrices = (payload: {
  ids: number[];
  year_before: number;
}): Promise<ReferencePriceProps> =>
  fetchAPI('/self/data_prices/highest', {
    method: 'POST',
    version: '1.2',
    payload,
  }).then(r => r.json());

export const getShopCategory = (
  category_id: number
): Promise<ChannelShopCategory> =>
  new Promise((resolve, reject) => {
    fetchAPI(`/channels/shop/categories/${category_id}`, {
      method: 'GET',
      version: '1.2',
    }).then(res => {
      if (res.ok) {
        return resolve(res.json());
      } else {
        return reject();
      }
    });
  });

export const autoAddBookmarkItems = (payload: {
  item_ids: number[];
}): Promise<{ isAdded: boolean }> =>
  fetchAPI('/self/data_item/prices/auto_bookmark', {
    payload,
    version: '1.2',
    method: 'POST',
  }).then(r => r.json());



// WEBPACK FOOTER //
// ./app/api/shop.ts